import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import MultivariatePaymentOptions from '@/app/components/MultivariatePaymentOptions';

export interface FooterMultivariatePaymentOptionsProps {
  readonly className?: string;
  readonly innerClassName?: string;
  readonly typographyClassName?: string;
}

const FooterMultivariatePaymentOptions = ({
  className,
  innerClassName,
  typographyClassName,
}: FooterMultivariatePaymentOptionsProps) => {
  const t = useTranslations();

  return (
    <div className={className} data-cy="footer-multivariate-payment-options">
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <div
            className={cx(
              'flex h-20 w-full flex-row items-center justify-center gap-8 rounded-md bg-[#282826] px-4 py-4',
              innerClassName,
            )}
          >
            <Typography
              className={cx(
                'hidden text-center font-bold tracking-wide text-sandstone-200 lg:block',
                typographyClassName,
              )}
            >
              {t('flexible_payment_options')}
            </Typography>
            <MultivariatePaymentOptions />
          </div>
        </GridItem>
      </LayoutGrid>
    </div>
  );
};

export default FooterMultivariatePaymentOptions;
